import React, { Component } from 'react'
import { connect } from 'react-redux'
// import Modal from 'react-bootstrap/lib/Modal'
import InfoCategories from './InfoCategories'
import InfoLanguage from './InfoLanguage'
import InfoImpact from './InfoImpact'
import InfoProfileVisibility from './InfoProfileVisibility'
import InfoSkills from './InfoSkills'
import InfoProfileStrength from './InfoProfileStrength'
import InfoProfilePicture from './InfoProfilePicture'
import InfoConnection from './InfoConnection'
import { Modal, ModalBody } from '@vmockinc/dashboard/Common/commonComps/Modal'
import FocusLock, { MoveFocusInside } from 'react-focus-lock'
import classNames from 'classnames'
import { injectIntl, FormattedMessage } from 'react-intl'
import InfoPresentation from './InfoPresentation'

const componentMap = {
  categories: InfoCategories,
  language: InfoLanguage,
  impact: InfoImpact,
  seo: InfoProfileVisibility,
  skills: InfoSkills,
  score: InfoProfileStrength,
  picture: InfoProfilePicture,
  connection: InfoConnection,
  presentation: InfoPresentation,
}


class InfoScreens extends Component {
  render() {
    const { show, module, currentSection, hideModal, isUKEnable, user, intl } = this.props
    const CurrentComponent = componentMap[module]
    const { extendModalClass = '' } = this.props
    const { community } = user

    return (
      <div>
        <FocusLock disabled={!show} returnFocus={true}>
          <Modal
            aria-label={intl.formatMessage({ id: "infoScreens.modalAriaLabel", defaultMessage: "Information modal" })}
            className={classNames('as-info-modal', extendModalClass)}
            isOpen={show}
            onRequestHide={hideModal}>
            <ModalBody>
              <CurrentComponent
                currentSection={currentSection}
                hideModal={hideModal}
                isUKEnable={isUKEnable}
                community={community}
                user={user}
              />
            </ModalBody>
          </Modal>
        </FocusLock>
      </div>
    )
  }
}


function mapStateToProps(state, ownProps) {
  return {
    user: state.user.data,
  }
}
export default connect(mapStateToProps, {})(injectIntl(InfoScreens))